import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'nowrap',
    overflow: 'auto',
    gap: '0.5rem',
    alignItems: 'center',
    scrollbarWidth: 'none',

    '&::-webkit-scrollbar': {
      width: 0,
      height: 0
    }
  },

  extraTagsRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '100rem',
    height: '18px',
    padding: '0 5px',
    background: theme.palette.primary.main,
    fontSize: theme.size.sm,
    color: 'white',
    cursor: 'pointer'
  }
}))

export default useStyles
